import { useState, useEffect, useRef } from 'react';
import './index.css';

import { parseAPIResultToData } from './helper';
import api from '../../../../apis';

import { Select, Tag, Tree, Spin } from 'antd';

const TreeNode = Tree.TreeNode;

const Index = ({
    // onChange,
    onSelectedDetails,
    singleMode = true,
    initialSelectFirst=true
}:any) => {
    const [visible, setVisible] = useState(false);
    const [searchKey, setSearchKey] = useState<any>('');
    const [options, setOptions] = useState([]);
    const [oriOptions, setOriOptions] = useState([]);
    const [expandedKeys, setExpandedKeys] = useState([]);

    const [checkedKeys, setCheckedKeys] = useState<any>([]);
    const [checkedKeysInfo, setCheckedKeysInfo] = useState([]);
    
    const [selectedValues, setSelectedValues] = useState([]);

    const [firstTimeRender, setFirstTimeRender] = useState(true);
    const [isLoading, setIsLoading] = useState(false);  

    const [trigger, setTrigger] = useState(0);

    const selectRef = useRef(null);
    const dropdownRef = useRef(null);
   
    useEffect(() => {
        requestSearchClientNameAccount(true);
          // Add event listener for clicks
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('mousedown', handleClickOnInput);

        // Cleanup the event listener on component unmount
        return () => {
            document.removeEventListener('mousedown', handleClickOnInput);
        };

    }, []);

    useEffect(() => {
        if (searchKey || searchKey == '') {
            const delayDebounceFn = setTimeout(() => {
                requestSearchClientNameAccount();
            }, 500);

            return () => clearTimeout(delayDebounceFn);
        }
    }, [searchKey]);

    //retrigger when click clear button
    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            requestSearchClientNameAccount(true);
        }, 400);

        return () => clearTimeout(delayDebounceFn);
        
    }, [trigger]);

    //pass back to parent
    useEffect(() => {
    //   if(onChange){
    //     onChange(checkedKeys);
    //   }
    }, [checkedKeys]);
 
    useEffect(() => {
        if(onSelectedDetails){
           // console.log("onSelectedDetails,",checkedKeys,checkedKeysInfo)
            onSelectedDetails(checkedKeys,checkedKeysInfo);
        }
    }, [checkedKeysInfo]);

    useEffect(() => {
        // if(singleMode == false){
        //     handleLockSelectionRules();
        // }
      
    }, [checkedKeys]);

    
    const handleClickOnInput = (event:any) => {
        // Check if the click is outside the ref element
        if (
            (selectRef.current && selectRef.current.contains(event.target)) 
        ) {

          setVisible((prev) => !prev);

        }


    };


    const handleClickOutside = (event:any) => {
    
        // Check if the click is outside the ref element
        if (
            (selectRef.current && !selectRef.current.contains(event.target)) &&
            (dropdownRef.current && !dropdownRef.current.contains(event.target))
        ) {
          setVisible(false);
        
        }

    };

    const requestSearchClientNameAccount = (isClear = false) => {
        setIsLoading(true)
       
        let _searchKey = searchKey;
        if(isClear){
            _searchKey = '';
        }
  
        return api.searchClientNameAccount(_searchKey).then((result: any) => {
            setIsLoading(false);
          //  console.log('searchClientNameAccount');
        //   console.log('searchClientNameAccount',result);
      
            let clients = result.clients;
       
            if (clients) {
                handleExpendedKeys(clients);

                let selectFirstValue = firstTimeRender?true:false;
                if(firstTimeRender && initialSelectFirst == false){
                    //off initial select first value
                    selectFirstValue = false
                }
                if(firstTimeRender == true){
                    setFirstTimeRender(false);
                }
                handleOptionsData(clients,selectFirstValue); 
            }
           
            // setTreeSelectLoading(false);
            // if (result.clients) updateTreeSelect(result.clients);
        });
    };

    //options
    // const treeData = [
    //     {
    //       title: 'parent 1',
    //       key: '0-0',
    //       checkable:false,
    //       disableCheckbox:true,
    //       selectable:false,
    //       children: [
     
    //         {
    //           title: 'parent 1-1',
    //           key: '0-0-1',
    //           checkable:true
    //         },
    //       ],
    //     },
    // ];

    const handleOptionsData = (data:any,selectFirstValue = false ) => {

        let checkedKeys:any = [];
        let checkedKeysInfo:any = [];

         let options = data.map((parent:any ,parentIdx:any)=> ({
            title: <>
                <div>{parent.p_fullname}</div>
                {/* <div>{parent.u_username}</div> */}
            </>,
            key: `${parent.p_fullname}-${parentIdx}`, // Generating unique key based on parent name
            checkable: false,
            disableCheckbox:true,
            selectable:false,
            children: parent.accounts && Array.isArray(parent.accounts) 
                ? parent.accounts.map((account:{a_acctno:string,a_id:string},childrenIdx:number) =>{
                    let value = {
                        parent_name: parent.p_fullname,
                        title: account.a_acctno.toString(),
                        key: account.a_id.toString(), // Converting number to string for key
                        
                    }
                    if(parentIdx == 0 && childrenIdx ==0){
                        checkedKeys.push(account.a_id.toString());
                        checkedKeysInfo.push(value);
                    }

                    return value;
                })
                : [], // Empty array if accounts is null or not an array
        }));

        setOptions(options)
        setOriOptions(options)


        //default select first value
        if(selectFirstValue == true){
            onCheck(checkedKeys, {checkedNodes:checkedKeysInfo});
        }else{
            if(firstTimeRender == true){
                onCheck([], {checkedNodes:checkedKeysInfo});
            }
          
        }
     
 
    };
    const handleExpendedKeys = (data:any) => {
        let keys:any =[];
        data.map((parent:any,idx:any) => {
            keys.push(`${parent.p_fullname}-${idx}`);
        });
        setExpandedKeys(keys);
    };
    

      
    // const onSelect = (selectedKeys, info) => {
    //     console.log('selected', selectedKeys, info);
    // };
    
    const onCheck = (checkedKeys:any, info:any) => {
        //  console.log('onCheck ', checkedKeys,info);
        //  console.log('singleMode ', singleMode);
 
        if(singleMode == true){

            if(checkedKeys.length == 0){
                //select latest only
                let newCheckedKeys = checkedKeys.length ? [checkedKeys[checkedKeys.length - 1]] : [];
                let newCheckedNodes = info.checkedNodes.length ? [info.checkedNodes[info.checkedNodes.length - 1]] : [];
                // console.log('onCheck newCheckedKeys', newCheckedKeys);
                setCheckedKeys(newCheckedKeys);
                setCheckedKeysInfo(newCheckedNodes);

                if(firstTimeRender && initialSelectFirst == false){
                    //off initial select first value
                    newCheckedNodes=[]
                }
                handleTransformSelectedInfo(newCheckedNodes);


                setVisible(false);
            }else {
            
                let newCheckedKeys = checkedKeys.length ? [checkedKeys[checkedKeys.length - 1]] : [];
                let newCheckedNodes = info.checkedNodes.length ? [info.checkedNodes[info.checkedNodes.length - 1]] : [];
         
                setCheckedKeys(newCheckedKeys);
                setCheckedKeysInfo(newCheckedNodes);
                handleTransformSelectedInfo(newCheckedNodes);

                setVisible(false);
            }
            
        }else{
            let newCheckedNodes = info.checkedNodes
            if(firstTimeRender && initialSelectFirst == false){
                //off initial select first value
                newCheckedNodes=[]
            }
            // console.log('new checkedKeys ', checkedKeys);
            // console.log('new newCheckedNodes ', newCheckedNodes);

            setCheckedKeys(checkedKeys);
            setCheckedKeysInfo(newCheckedNodes);
            handleTransformSelectedInfo(newCheckedNodes);
        }
        

      

    };


    const handleTransformSelectedInfo = (infos:any) => {
        let values:any =[];
        infos.map((info:any ,idx:any ) => {
            values.push({
                "label":info.title,
                "value":info.key
            })
        });
       // console.log("setSelectedValues ",values)
        setSelectedValues(values);
    };

    const handleClear = () => {
     // console.log("handleClear")
        setCheckedKeys([]);
        setCheckedKeysInfo([]);
        setSelectedValues([]);

        setSearchKey("");
        setTrigger(prev => prev + 1);

    }

    const handleRemoveValue = (value:string) => {
       // console.log("handleRemoveValue",value)
        // let newSelectedValues = selectedValues.filter((item) => item.value !== value);
        // setSelectedValues(newSelectedValues);


        //update treenode start
        //---remove key from checkedKeys
        const updatedCheckedKeys = checkedKeys.filter((key: string) => key !== value);
        setCheckedKeys(updatedCheckedKeys);

       // console.log("checkedKeysInfo123 0,",checkedKeysInfo)
        const updatedCheckedKeysInfo = checkedKeysInfo.filter((item:any) => item.key !== value);
        setCheckedKeysInfo(updatedCheckedKeysInfo);
        //---update treenode end

        //---update select box start
        const updatedSelectedValues = selectedValues.filter((item:any) => item.value !== value);
        setSelectedValues(updatedSelectedValues);
        //---update select box end

        // console.log("updatedCheckedKeys",updatedCheckedKeys)
        // console.log("updatedCheckedKeysInfo",updatedCheckedKeysInfo)
        // console.log("updatedSelectedValues",updatedSelectedValues)
        if(updatedSelectedValues.length == 0){
            handleClear();
        }
    }

    interface Child {
        key: string;
        [key: string]: any; // Allow additional properties
    }

    interface Parent {
        key: string;
        children: Child[];
        [key: string]: any; // Allow additional properties
    }
    const handleLockSelectionRules = (lock:boolean = false) => {
       // console.log("options556 ",options,checkedKeys)

        if(checkedKeys.length > 0){
            let newOptions:any = options.map((parent:any) => {
                let newChildren=[]
                if(parent.children){
                   newChildren = parent.children.map((child:any) => {
                        let newChild = {...child};
                        let key = child.key;
                        if(checkedKeys.includes(key)){
                            newChild.disabled = false;
                        }else{
                            newChild.disabled = true;
                        }
                        return newChild;
                    });
                }
                
                return {...parent,children:newChildren};
            });
            setOptions(newOptions);
        }else{
            setOptions(oriOptions);
        }
    }

    
    return (
        <>
        {/* {checkedKeys } */}
            <div  ref={selectRef} style={{width:'100%',height:'100%'}}>
                <Select
                
                     open={visible}
                    loading={isLoading}
                    // open={true}
                    className='user-acc-tree-select-input'
                    popupClassName={'user-acc-tree-select-container'}
                    allowClear
                    onClear={()=>handleClear()}
                    mode="multiple"
                    style={{ width: '100%' }}
                    dropdownStyle={{ maxHeight: 700, overflow: 'auto' }}
                    placeholder="Please Select"
                    tagRender={({ label, value, closable, onClose }) => {
                        //console.log("props",props)
                        return <Tag
                            closable={closable}
                            onClose={()=>handleRemoveValue(value)}
                        >
                        {label}
                        </Tag>
                    }}
                    value={selectedValues}
                    // defaultValue={['china']}
                    // onChange={handleChange}
                    optionLabelProp="label"
                    dropdownRender={(originNode)=>{
                        return (<>
                        
                        <div  ref={dropdownRef}>
                            {isLoading ? (
                                <div style={{ textAlign: 'center', padding: 20 }}>
                                    <Spin size="small" />
                                </div>
                            ) : (
                                <Tree
                                
                                checkable
                                // defaultExpandedKeys={['0-0-0', '0-0-1']}
                                // defaultSelectedKeys={['0-0-0', '0-0-1']}
                                // defaultCheckedKeys={['0-0-0', '0-0-1']}
                                // onSelect={onSelect}
                                selectable={false}
                                onCheck={onCheck}
                                treeData={options}
                                expandedKeys={expandedKeys}
                                defaultExpandParent={true}
                                defaultExpandAll
                                checkedKeys={checkedKeys}
                            />
                            )}
                          
                            {
                                isLoading == false && options.length == 0 && (
                                    <div style={{ textAlign: 'center', padding: 20 }}>
                                        No Data
                                    </div>
                                )
                            }
                            
                        </div>
                        </>)
                    }}
                    //onInputKeyDown={()=>setVisible(!visible)}
                    // onMouseEnter={()=>setVisible(true)}
                    // onMouseLeave={()=>setVisible(false)}
                    // onBlur={()=>setVisible(false)}
                    // onInputKeyDown={()=>setVisible(true)}
                    onSearch={(value) => {
                        setSearchKey(value)

                        if(!visible){
                            setVisible(true);
                        }
                    }}
                />
            </div>
        </>
    );
};

export default Index;
